import React from 'react'
import Botones from './Botones'
import { useValidarImagen } from '../../../hooks/useValidarImagen'

const rutaImg = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + process.env.REACT_APP_IMAGENES


const BotonImagen = (props) => {
    const { widthImg, heightImg, urlImg, shadowsImg } = props?.styles

    return (
        <a href={props?.styles?.hipervinculo}>
            <div className='boton-imagen-container'>
                <img
                    className={`${shadowsImg && `z-depth-${shadowsImg}`}`}
                    src={useValidarImagen(urlImg)}
                    height={heightImg}
                    width={widthImg}
                />
                <Botones {...props} />
            </div>
        </a>
    )
}

export default BotonImagen